import HowToPlayListItem from "app/ui/HowToPlayListItem";
import TypoWord from "app/ui/TypoWord";
import tutGif from "app/assets/one-chance-tut-gif-1.gif";
import cn from "app/utils/classnames";

export default function getOneChanceInstructions(): React.ReactNode {
  return (
    <>
      <ul className={cn("list-disc", "pl-4", "flex flex-col gap-2")}>
        <HowToPlayListItem key={0}>
          <TypoWord word="Spell" /> a <TypoWord word="really" /> hard word to{" "}
          <TypoWord word="multiply" /> your score.
        </HowToPlayListItem>
        <HowToPlayListItem key={1}>
          You only get one <TypoWord word="chance" />.
        </HowToPlayListItem>
        <HowToPlayListItem key={2}>
          You can reveal clues, including <TypoWord word="individual" /> letters
          and the word's length. Each will <TypoWord word="slightly" />{" "}
          <TypoWord word="decrease" /> your multiplier.
        </HowToPlayListItem>
      </ul>
      <img width={357} height={167} src={tutGif} />
    </>
  );
}
